<template>
  <div class="tag-setting">
    <div class="section-header">
      <h3 class="section-title">
        <i class="el-icon-collection-tag"></i>
        标签管理
      </h3>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="onAddTag">
        新建标签
      </el-button>
    </div>

    <!-- 空状态 -->
    <div v-if="tags.length === 0" class="empty-state">
      <div class="empty-icon">
        <i class="el-icon-collection-tag"></i>
      </div>
      <div class="empty-text">还没有标签</div>
      <div class="empty-sub">点击上方按钮创建标签</div>
    </div>

    <!-- 标签列表 -->
    <div v-else class="tag-list">
      <div v-for="tag in tags" :key="tag.id" class="tag-item" @click="onTagDetail(tag)">
        <div class="tag-info">
          <div class="tag-name">{{ tag.name }}</div>
          <div class="tag-count">{{ tag.memberCount }} 位员工</div>
        </div>
        <div class="tag-actions">
          <el-button type="text" size="small" @click.stop="onTagDetail(tag)">
            <i class="el-icon-edit"></i>
          </el-button>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>

    <!-- 新建/编辑标签弹窗 -->
    <el-dialog
      :title="editingTag ? '编辑标签' : '新建标签'"
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form :model="tagForm" :rules="tagRules" ref="tagFormRef" @submit.native.prevent>
        <el-form-item prop="name">
          <el-input
            v-model="tagForm.name"
            placeholder="请输入标签名称"
            maxlength="20"
            show-word-limit
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancelDialog">取 消</el-button>
        <el-button type="primary" @click="onConfirmDialog" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="确认删除"
      :visible.sync="deleteDialogVisible"
      width="360px"
    >
      <div class="delete-content">
        <i class="el-icon-warning"></i>
        <span>确定删除标签 "{{ deleteTagName }}" 吗？</span>
      </div>
      <span slot="footer">
        <el-button @click="deleteDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="onConfirmDelete" :loading="loading">删 除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TagSetting",
  data() {
    return {
      tags: [],
      dialogVisible: false,
      deleteDialogVisible: false,
      editingTag: null,
      deleteTagName: '',
      deleteTagId: null,
      loading: false,
      tagForm: {
        name: ''
      },
      tagRules: {
        name: [
          { required: true, message: '请输入标签名称', trigger: 'blur' },
          { min: 1, max: 20, message: '标签名称在 1 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadTags();
    },
    loadTags() {
      this.$http({
        url: '/friend/tag/list',
        method: 'get'
      }).then(data => {
        this.tags = data || [];
      }).catch(() => {
        this.$message.error('加载标签失败');
      });
    },
    onAddTag() {
      this.editingTag = null;
      this.tagForm.name = '';
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.tagFormRef) {
          this.$refs.tagFormRef.clearValidate();
        }
      });
    },
    onEditTag(tag) {
      this.editingTag = tag;
      this.tagForm.name = tag.name;
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.tagFormRef) {
          this.$refs.tagFormRef.clearValidate();
        }
      });
    },
    openEditDialog(tag) {
      this.onEditTag(tag);
    },
    onCancelDialog() {
      this.dialogVisible = false;
      // 如果是编辑模式且没有输入新名称，则显示删除确认
      if (this.editingTag && this.tagForm.name === this.editingTag.name) {
        this.deleteTagName = this.editingTag.name;
        this.deleteTagId = this.editingTag.id;
        this.deleteDialogVisible = true;
      }
      this.editingTag = null;
      this.tagForm.name = '';
    },
    onConfirmDialog() {
      this.$refs.tagFormRef.validate(valid => {
        if (!valid) return;
        
        if (!this.tagForm.name.trim()) {
          this.$message.warning('标签名称不能为空');
          return;
        }

        this.loading = true;
        if (this.editingTag) {
          // 编辑标签
          this.$http({
            url: '/friend/tag/update',
            method: 'put',
            data: { id: this.editingTag.id, name: this.tagForm.name.trim() }
          }).then(() => {
            this.$message.success('修改成功');
            this.dialogVisible = false;
            this.editingTag = null;
            this.tagForm.name = '';
            this.loadTags();
          }).catch(() => {
            this.$message.error('修改失败');
          }).finally(() => {
            this.loading = false;
          });
        } else {
          // 新建标签
          this.$http({
            url: '/friend/tag/create',
            method: 'post',
            data: { name: this.tagForm.name.trim() }
          }).then(() => {
            this.$message.success('创建成功');
            this.dialogVisible = false;
            this.tagForm.name = '';
            this.loadTags();
          }).catch(() => {
            this.$message.error('创建失败');
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    onConfirmDelete() {
      if (!this.deleteTagId) return;
      
      this.loading = true;
      this.$http({
        url: `/friend/tag/delete/${this.deleteTagId}`,
        method: 'delete'
      }).then(() => {
        this.$message.success('删除成功');
        this.deleteDialogVisible = false;
        this.deleteTagId = null;
        this.deleteTagName = '';
        this.editingTag = null;
        this.tagForm.name = '';
        this.loadTags();
      }).catch(() => {
        this.$message.error('删除失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    onTagDetail(tag) {
      this.$emit('view-tag', tag.id, tag.name);
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-setting {
  padding: 15px;
  background: #fafbfc;
  min-height: 400px;

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .section-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--im-text-color-primary);

      i {
        color: var(--im-color-primary);
        font-size: 18px;
      }
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;

    .empty-icon {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: linear-gradient(135deg, #f0f7ff 0%, #e8f4ff 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      i {
        font-size: 36px;
        color: #b3d8fd;
      }
    }

    .empty-text {
      font-size: 16px;
      color: #666;
      margin-bottom: 8px;
    }

    .empty-sub {
      font-size: 14px;
      color: #999;
    }
  }

  .tag-list {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;
    overflow: hidden;

    .tag-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px;
      border-bottom: 1px solid #f5f5f5;
      cursor: pointer;
      transition: background 0.2s;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background: #fafafa;
      }

      .tag-info {
        flex: 1;

        .tag-name {
          font-size: 15px;
          color: #333;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .tag-count {
          font-size: 13px;
          color: #999;
        }
      }

      .tag-actions {
        display: flex;
        align-items: center;
        gap: 8px;

        .el-button {
          padding: 4px 8px;
        }

        i {
          color: #999;
          font-size: 14px;
        }
      }
    }
  }

  .delete-content {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;

    i {
      color: #e6a23c;
      font-size: 20px;
    }
  }
}
</style>
